import axios from "axios";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Api_Url } from "../../../config/config";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import e from "cors";

const UserEmployeeFilterPage = ({ parentFunctionLeads }) => {
  const [focusedClientId, setFocusedClientId] = useState(false);
  const [inputValueClientId, setInputValueClientId] = useState(null);
  const [branch, setBranch] = useState([]);
  const [activity, setActivity] = useState([]);
  const [selectDepartmentId, setSelectDepartmentId] = useState(null);
  const [inputSourceDesignationName, setInputSourceDesignationName] =
    useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [teamMembers, setTeamMembers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userId, setUserId] = useState("");
  const [allDesignation, setAllDesignation] = useState([]);
  const [allDepartment, setAllDepartment] = useState([]);
  const [mobileFilter, setMobileFilter] = useState("");
  const [nameFilter, setNameFilter] = useState("");
  const [codeFilter, setCodeFilter] = useState("");
  const [emailFilter, setEmailFilter] = useState("");

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#ff9b44" : "#fff",
      color: state.isFocused ? "#fff" : "#000",
      "&:hover": {
        backgroundColor: "#ff9b44",
      },
    }),
  };

  useEffect(() => {
    const id = JSON.parse(sessionStorage.getItem("user"))?.id;
    setUserId(id);
  }, []);

  const handleDataBranchFunc = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/Branch?PageNumber=1&PageSize=100`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setBranch([{ id: "all", name: "Select All" }, ...response?.data?.data]);
    } catch (error) {
      console.error("branch data error", error);
    }
  };

  const AllDesignationName = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/Designation?PageNumber=1&PageSize=100`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setAllDesignation([
        { id: "all", name: "Select All" },
        ...response.data.data,
      ]);
    } catch (error) {
      console.error(error);
    }
  };

  const AllDepratmentName = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/Department?PageNumber=1&PageSize=100`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setAllDepartment([
        { id: "all", name: "Select All" },
        ...response.data.data,
      ]);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    handleDataBranchFunc();
    AllDesignationName();
    AllDepratmentName();
  }, []);

  const handleBranchChange = (selectedOption) => {
    setInputValueClientId(selectedOption);
  };

  const handleActivityChange = (selectedOption) => {
    setSelectDepartmentId(selectedOption);
  };

  const handleTeamMembers = (selectedOption) => {
    setInputSourceDesignationName(selectedOption);
  };

  const handleFilterApply = async () => {
    const filters = [];
    if (inputValueClientId && inputValueClientId.value !== "all") {
      filters.push(`BranchId=${inputValueClientId.value}`);
    }
    if (
      inputSourceDesignationName &&
      inputSourceDesignationName.value !== "all"
    ) {
      filters.push(`DesignationId=${inputSourceDesignationName.value}`);
    }
    if (selectDepartmentId && selectDepartmentId.value !== "all") {
      filters.push(`DepartmentId=${selectDepartmentId.value}`);
    }
    if (mobileFilter) {
      filters.push(`Mobile=${mobileFilter}`);
    }
    if (nameFilter) {
      filters.push(`FirstName=${nameFilter}`);
    }
    if (codeFilter) {
      filters.push(`Code=${codeFilter}`);
    }
    if (emailFilter) {
      filters.push(`Email=${emailFilter}`);
    }
    try {
      const queryString = `?${filters.join("&")}`;
      parentFunctionLeads([]);
      const response = await axios.get(
        `${Api_Url}api/v1/UserProfile${queryString}&PageNumber=1&PageSize=100`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      parentFunctionLeads(response.data.data);
    } catch (error) {
      console.error("Error filtering activities", error);
    }
  };

  return (
    <>
      <div className="row filter-row">
        <div className="col-sm-6 col-md-3">
          <div
            className={
              focusedClientId
                ? "input-block form-focus focused"
                : "input-block form-focus"
            }
          >
            <Select
              options={branch.map((b) => ({ value: b.id, label: b.name }))}
              value={inputValueClientId}
              onChange={handleBranchChange}
              onFocus={() => setFocusedClientId(true)}
              onBlur={() =>
                setFocusedClientId(inputValueClientId ? true : false)
              }
              placeholder="Select Branch"
              styles={customStyles}
            />
          </div>
        </div>
        <div className="col-sm-6 col-md-3">
          <div
            className={
              focusedClientId
                ? "input-block form-focus focused"
                : "input-block form-focus"
            }
          >
            <Select
              options={allDepartment.map((a) => ({
                value: a.id,
                label: a.name,
              }))}
              value={selectDepartmentId}
              onChange={handleActivityChange}
              onFocus={() => setFocusedClientId(true)}
              onBlur={() =>
                setFocusedClientId(selectDepartmentId ? true : false)
              }
              placeholder="Select Department"
              styles={customStyles}
            />
          </div>
        </div>

        <div className="col-sm-6 col-md-3">
          <div className="input-block form-focus select-focus">
            <Select
              options={allDesignation.map((s) => ({
                value: s.id,
                label: `${s.name}`,
              }))}
              onChange={handleTeamMembers}
              placeholder="Select Designation"
              styles={customStyles}
              value={inputSourceDesignationName}
            />
          </div>
        </div>

        {/* New Input field for Name filter */}
        <div className="col-sm-6 col-md-3">
          <div className="input-block form-focus">
            <input
              type="number"
              className="form-control"
              placeholder="Enter Mobile Number"
              value={mobileFilter}
              onChange={(e) => setMobileFilter(e.target.value)}
            />
          </div>
        </div>

        <div className="col-sm-6 col-md-3">
          <div className="input-block form-focus">
            <input
              type="text"
              className="form-control"
              placeholder="Enter FirstName"
              value={nameFilter}
              onChange={(e) => setNameFilter(e.target.value)}
            />
          </div>
        </div>

        <div className="col-sm-6 col-md-3">
          <div className="input-block form-focus">
            <input
              type="text"
              className="form-control"
              placeholder="Enter Code"
              value={codeFilter}
              onChange={(e) => setCodeFilter(e.target.value)}
            />
          </div>
        </div>

        <div className="col-sm-6 col-md-3">
          <div className="input-block form-focus">
            <input
              type="text"
              className="form-control"
              placeholder="Enter Email Address"
              value={emailFilter}
              onChange={(e) => setEmailFilter(e.target.value)}
            />
          </div>
        </div>

        <div className="col-sm-6 col-md-3">
          <button
            className="btn btn-success btn-block w-100"
            onClick={handleFilterApply}
          >
            Apply Filter
          </button>
        </div>
      </div>
    </>
  );
};

export default UserEmployeeFilterPage;
